import { render } from "./GameResultsView.vue?vue&type=template&id=211bf926"
import script from "./GameResultsView.vue?vue&type=script&lang=js"
export * from "./GameResultsView.vue?vue&type=script&lang=js"

import "./GameResultsView.vue?vue&type=style&index=0&id=211bf926&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__